import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import moment from 'moment';
import { feedbackFileUrl } from '../../../util/file_url';

function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

const useStyles = makeStyles((theme) => ({
    paper: {
        position: 'absolute',
        width: "80%",
        maxWidth: "800px",
        maxHeight: "80%",
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        overflow: 'auto',
    },
    closeButton: {
        position: 'absolute',
        right: '10px',
        top: '10px',
        cursor: 'pointer',
        fontSize: '20px',
        color: '#666',
        '&:hover': {
            color: '#000',
        },
    },
    attachmentContent: {
        marginTop: '20px',
        textAlign: 'center',
    },
    image: {
        maxWidth: '100%',
        maxHeight: '70vh',
        objectFit: 'contain',
    },
    video: {
        maxWidth: '100%',
        maxHeight: '70vh',
    },
    audio: {
        width: '100%',
        maxWidth: '400px',
    },
    fileInfo: {
        marginTop: '10px',
        textAlign: 'left',
        fontSize: '14px',
        color: '#666',
    },
}));

export default function AttachmentModal({
    closeModal, 
    attachment, 
    feedback 
}) {
    const classes = useStyles();
    const [modalStyle] = React.useState(getModalStyle);

    const renderAttachment = () => {
        if (!attachment) return null;

        let src = (feedback && feedback.wip_id)
            ? feedbackFileUrl(attachment)
            : URL.createObjectURL(attachment);

        // Image files
        if (attachment.type && attachment.type.startsWith('image/')) {
            return (
                <img 
                    src={src}  
                    className={classes.image}
                    alt={attachment.name || 'Attachment'}
                />
            );
        }

        // Video files
        if (attachment.type && attachment.type.startsWith('video/')) {
            return (
                <video 
                    src={src} 
                    controls
                    className={classes.video}
                >
                    Your browser does not support the video element.
                </video>
            );
        }

        // Audio files
        if (attachment.type && attachment.type.startsWith('audio/')) {
            return (
                <audio 
                    src={src} 
                    controls
                    className={classes.audio}
                >
                    Your browser does not support the audio element.
                </audio>
            );
        }

        // PDF files
        if (attachment.type === 'application/pdf') {
            return (
                <iframe
                    src={src}
                    width="100%"
                    height="70vh"
                    title={attachment.name || 'PDF Document'}
                />
            );
        }

        // Default for other file types
        return (
            <div style={{ textAlign: 'center', padding: '20px' }}>
                <i className="far fa-file" style={{ fontSize: '48px', color: '#666' }}></i>
                <p style={{ marginTop: '10px' }}>{attachment.name || 'File'}</p>
                <a href={src} download={attachment.name} className="button clickable">
                    Download File
                </a>
            </div>
        );
    };

    return (
        <Modal
            open={true}
            onClose={closeModal}
            aria-labelledby="attachment-modal-title"
            aria-describedby="attachment-modal-description"
        >
            <div style={modalStyle} className={classes.paper}>
                <i 
                    onClick={closeModal} 
                    className={`fa fa-times ${classes.closeButton}`} 
                    aria-hidden="true"
                ></i>
                
                <div className={classes.attachmentContent}>
                    {renderAttachment()}
                    
                    {feedback && (
                        <div className={classes.fileInfo}>
                            <p><strong>Posted by:</strong> {feedback.username}</p>
                            <p><strong>Date:</strong> {moment.utc(feedback.date).local(true).format("MM/DD/YYYY hh:mm A")}</p>
                            {attachment.name && <p><strong>File:</strong> {attachment.name}</p>}
                        </div>
                    )}
                </div>
            </div>
        </Modal>
    );
} 